import React, { useRef, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { StyledDialog, StyledDialogContent, FlexEndContainer, FlexColumn, WhiteBGContainer } from '../styles/Containers'
import { WarningMessage } from '../common/UserMessage'
import Button, { SecondaryButton } from '../common/Button'
import { BoldFormTitle } from '../styles/Text'
import pirTerminology from '../../util/pirTerminology'

const BoldText = styled.span`
  font-weight: 500;
`

function EditButton({ onProceed = () => {}, loading = false }) {
  const [isVisible, setIsVisible] = useState(false)

  const isMounted = useRef(true)
  useEffect(() => {
    return () => {
      isMounted.current = isVisible
    }
  }, [])

  const handleOpen = () => setIsVisible(true)
  const handleClose = () => setIsVisible(false)
  function handleProceed() {
    setIsVisible(false)
    onProceed()
  }

  return (
    <>
      <SecondaryButton onClick={handleOpen} loading={loading}>
        Edit {pirTerminology.getRequestShortName()}
      </SecondaryButton>
      <StyledDialog fullWidth open={isVisible} onClose={handleClose} keepMounted={false}>
        <StyledDialogContent>
          <WhiteBGContainer padding="30px">
            <FlexColumn>
              <BoldFormTitle>Warning</BoldFormTitle>
              <WarningMessage>
                <div>
                  This action will revert the {pirTerminology.getRequestShortName()} status to <BoldText>READY</BoldText>. The requestor will not be
                  notified until the {pirTerminology.getRequestShortName()} is submitted again.
                </div>
              </WarningMessage>
              <FlexEndContainer>
                <SecondaryButton onClick={handleClose}>Cancel</SecondaryButton>
                <Button onClick={handleProceed}>Proceed</Button>
              </FlexEndContainer>
            </FlexColumn>
          </WhiteBGContainer>
        </StyledDialogContent>
      </StyledDialog>
    </>
  )
}

EditButton.propTypes = {
  onProceed: PropTypes.func,
  loading: PropTypes.bool
}

export default EditButton
